
define(
	'Code25.CaterpartsGlobal.Quotes'
	, [
		"SC.Configuration", "Utils", "Tools", 'GlobalViews.Message.View', "Profile.Model", "Transaction.Model", "Code25.CaterpartsGlobal.AdvQuotes"
	]
	, function (
		Configuration, Utils, Tools, GlobalViewsMessageView, ProfileModel, TransactionModel, AdvQuotes
	) {
		'use strict';

		return {
			mount: function mountToApp(container) {

				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');

				if (layout && SC.ENVIRONMENT.permissions && SC.ENVIRONMENT.permissions.transactions.tranEstimate >= 2) {


					var myaccountmenu = container.getComponent("MyAccountMenu");
					if (myaccountmenu) {


						var requestaquote = {
							id: "requestaquote2",
							groupid: "orders",
							name: Utils.translate("Request a Quote"),
							index: 7,
							url: "request-a-quote"
						}

						myaccountmenu.addGroupEntry(requestaquote);


					}

					if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {

						var ProductDetailToQuoteView = require("ProductDetailToQuote.View");

						ProductDetailToQuoteView.prototype.childViews['GlobalViews.FeedbackMessage'] = function () {
							var message = this.state.feedbackMessage;
							this.state.feedbackMessage = '';


							Tools.showConfirmInModal(container, Utils.translate("Add to Quote"), Utils.translate(message), function (res) {

								document.location.href = "/s/my_account.ssp?fragment=request-a-quote";

							}, Utils.translate("View Quote"), Utils.translate("OK"))

						}
					}

					if (SC.ENVIRONMENT.SCTouchpoint == "myaccount") {

						var RequestQuoteWizardModuleComments = require('RequestQuoteWizard.Module.Comments');
						if (RequestQuoteWizardModuleComments) {

							if (RequestQuoteWizardModuleComments.RequestQuoteWizardModuleComments) {
								RequestQuoteWizardModuleComments = RequestQuoteWizardModuleComments.RequestQuoteWizardModuleComments;
							}
							_.extend(RequestQuoteWizardModuleComments.prototype, {

								submit: function () {

									this.wizard.model.set('custbody_aa_special_notes_trans', this.$('[data-type="memo-input"]').val());
									this.wizard.model.set('purchasenumber', this.$('[data-type="purchasenumber-input"]').val() || "");
									this.wizard.model.set('otherrefnum', this.$('[data-type="purchasenumber-input"]').val() || "");
									this.wizard.model.set('custbody_c25_web_shipcomplete', this.$('[name="custbody_c25_web_shipcomplete"]').val() || "");
									this.wizard.model.set('shipmethod', this.$('[data-type="shipmethod-input"]').val() || "");

									var QuoteCustomer = Tools.getValue("QuoteCustomer");
									if (QuoteCustomer) {
										//console.log("submit", this.wizard.model);


										var shipaddress = this.wizard.model.get("shipaddress");
										var billaddress = this.wizard.model.get("billaddress");

										var foundShip = false, foundBill = false;

										var addresses = this.wizard.model.get("addresses") || [];


										for (var i = 0; i < addresses.length; i++) {
											if (addresses.models[i].get("internalid") == shipaddress) {
												foundShip = true;
											}
											if (addresses.models[i].get("internalid") == billaddress) {
												foundBill = true
											}
										}
										if (!foundShip) {
											if (foundBill) {
												this.wizard.model.set("shipaddress", billaddress);
											} else {
												this.wizard.model.set("shipaddress", null);
											}
										}
										if (!foundBill) {
											if (foundShip) {
												this.wizard.model.set("billaddress", shipaddress);
											} else {
												this.wizard.model.set("billaddress", null);
											}
										}


									}

									return jQuery.Deferred().resolve();
								},
								getContext: _.wrap(RequestQuoteWizardModuleComments.prototype.getContext, function (getContext) {

									var res = getContext.apply(this, _.rest(arguments));

									res.purchasenumber = this.wizard.model.get('purchasenumber');
									res.custbody_c25_web_shipcomplete = this.wizard.model.get('custbody_c25_web_shipcomplete');
									res.shippingMethods = [];
									var shipmethods = this.wizard.model.get("shipmethods") || [];

									var shipmethod = this.wizard.model.get("shipmethod") || "", method;
									for (var i = 0; i < shipmethods.length; i++) {
										method = shipmethods.models[i].attributes;
										method.isActive = method.internalid == shipmethod;
										res.shippingMethods.push(method);

									}
									// 

									return res;

								})
							});
						}

						var QuoteDetailsView = require('Quote.Details.View');
						if (QuoteDetailsView) {

							if (QuoteDetailsView.QuoteDetailsView) {
								QuoteDetailsView = QuoteDetailsView.QuoteDetailsView;
							}
							window.modifyQuote = function (internalid) {

								Tools.showConfirmInModal(container, Utils.translate("Modify this Quote"), Utils.translate("Are you sure you want to modify this quote?<br /><br />A new quote will be created."), function (res) {
									//console.log(internalid);

									try {
										var model = new AdvQuotes();

										model
											.fetch({
												data: {
													task: "modify",
													t: new Date().getTime(),
													id: internalid
												}
											})
											.done(function (res) {

												if (res.ok) {
													Backbone.history.navigate('request-a-quote', { trigger: true });
												} else {
													Tools.showErrorInModal(container, Utils.translate("Unable to modify this Quote"), Utils.translate(res.error));
												}
											});
									} catch (err) {
										console.error(err);
									}

								})
							}

							QuoteDetailsView.prototype.events = QuoteDetailsView.prototype.events || {};
							QuoteDetailsView.prototype.events['click [data-action="modify-quote"]'] = 'modifyQuote';



						}

					}

				}

			}
		};
	});
